import ScheduleReport from './ScheduleReport';

export default ScheduleReport;
